module.exports = __webpack_public_path__ + "img/btn-lesson-flow@3x.c38130f0.jpg";